import CardEditProduct from 'components/Cards/CardEditProduct'
import React from 'react'

export const EditProduct = () => {
  return (
    <>
    <div className="flex flex-wrap mt-4 ">
      <div className="w-full px-4 mb-12 ">
       <CardEditProduct></CardEditProduct>
      </div>
    </div>
  </>
  )
}
